import React from 'react';
import ContactComponent from '../components/ContactComponent';

const Consult: React.FC = () => {
  return (
    <div>
      <ContactComponent />
     </div>
  );
};

export default Consult;